import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent, SportFilterComponent, PromoCodeComponent, DateFilterComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, PlatformService
} from "@varsity/services";
import { ToastController, PopoverController, Popover } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the FooterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'footer',
    templateUrl: 'footer.html'
})
export class FooterComponent extends BaseComponent {
    // Sports filter
    @Input() public filterOptions: { Icon: string, Name: string, IsSelected: boolean }[];
    @Output() public filterSelectHandler: EventEmitter<any> = new EventEmitter();
    @Input() public displaySportFilterButton: boolean = false;

    // Promo code
    @Input() public promoCodeParam: string;
    @Input() public displayPromoButton: boolean = false;
    @Output() public promoCodeApplyHandler: EventEmitter<any> = new EventEmitter();

    // UseBestSeats code
    @Input() public useBestSeats: boolean;
    @Input() public displayUseBestSeatSelection: boolean = true;
    @Output() public useBestSeatsChangeHandler: EventEmitter<any> = new EventEmitter();

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected toastCtrl: ToastController,
        protected popoverCtrl: PopoverController,
        protected platformService: PlatformService,
        protected iab: InAppBrowser,
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "FooterComponent"
        );

        
    }

    ngOnInit() {
        super.ngOnInit();
        if (!this.filterOptions || this.filterOptions.length == 0) {
            this.displaySportFilterButton = false;
        }
    }

    showFiltersPopover() {
        let p: Popover;
        p = this.popoverCtrl.create(SportFilterComponent,
            {
                "filters": this.filterOptions,
                "filterSelect": (filter: { Icon: string, Name: string, IsSelected: boolean }) => {
                    this.filterSelectHandler.emit(filter);
                }
            },
            {
                enableBackdropDismiss: false,
                cssClass: 'login-popover'
            }
        );

        p.present();
        
    }

    showPromoInputPopover() {
        let p: Popover;

        p = this.popoverCtrl.create(PromoCodeComponent,
            {
                "promoCode": this.promoCodeParam,
                "promoCodeApply": (promo: string) => {
                    this.promoCodeApplyHandler.emit(promo);
                }
            },
            {
                enableBackdropDismiss: false,
                cssClass: 'login-popover'
            }
        );

        p.present();
    }

    seatSelectionClick() {
        this.useBestSeatsChangeHandler.emit();
    }
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.ts